export function tryParseUrl(address: string) {
  try {
    return new URL(address)
  } catch (error) {
    return undefined
  }
}